export default __webpack_public_path__ + "static/media/kovy.be7ee589.svg";